import { useEffect, useState } from 'react';
import { useOrderStore, useResourceStore } from './store';
import { loadReferenceData } from './services/dataService';
import Dashboard from './components/Dashboard/Dashboard';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const setOrders = useOrderStore((state) => state.setOrders);
  const setMainWorkOrders = useOrderStore((state) => state.setMainWorkOrders);
  const setSubWorkOrders = useOrderStore((state) => state.setSubWorkOrders);
  const setPersons = useResourceStore((state) => state.setPersons);
  const setMachines = useResourceStore((state) => state.setMachines);
  const setMaterials = useResourceStore((state) => state.setMaterials);
  const setProducts = useResourceStore((state) => state.setProducts);
  const setWorkflows = useResourceStore((state) => state.setWorkflows);

  useEffect(() => {
    loadReferenceData()
      .then((data) => {
        setOrders(data.orders);
        setMainWorkOrders(data.mainWorkOrders);
        setSubWorkOrders(data.subWorkOrders);
        setPersons(data.persons);
        setMachines(data.machines);
        setMaterials(data.materials);
        setProducts(data.products);
        setWorkflows(data.workflows);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load reference data:', err);
        setError('無法載入資料，請重新整理頁面');
        setIsLoading(false);
      });
  }, [
    setOrders,
    setMainWorkOrders,
    setSubWorkOrders,
    setPersons,
    setMachines,
    setMaterials,
    setProducts,
    setWorkflows,
  ]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">載入中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center text-red-600">
          <p className="text-xl mb-4">⚠️ {error}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            重新整理
          </button>
        </div>
      </div>
    );
  }

  return <Dashboard />;
}

export default App;
